<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            {{ title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container resources-container">
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div
                v-for="(post,index) in resources"
                :key="post.id"
                class="col-sm-12"
              >
                <article
                  class="card mb-3 mb-sm-4"
                  :style="{animationDelay: index++ * 50 + 'ms'}"
                >
                  <div class="card-body">
                    <div class="card-resource-info">
                      <h6>{{ post.title }}</h6>
                    </div>
                    <div class="card-resource-btn-wrapper">
                      <a
                        v-file-opener
                        :href="post.file.path"
                        target="_blank"
                        class="btn btn-info btn-sm m-1 btn-download"
                      >View | Download</a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <pagination
                  :data="pagination"
                  :limit="1"
                  @pagination-change-page="setPage"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <!--                        <div class="float-wrapper" v-scroll="handleScroll"></div>-->
            <div>
              <div>
                <div />
              </div>
              <search />
              <resources :resources="resources" />
              <categories
                v-show="categories.length != 0"
                :categories="categories"
              />
              <tags
                v-show="tags.length != 0"
                :tags="tags"
              />
              <div>
                <a
                  href="https://store.foodfitnessfirst.com/"
                  class="btn btn-block btn-warning"
                  target="_blank"
                >
                  <div
                    class="store-link-text"
                  >Visit our online store HERE to purchase your FOOD SPIRAL® book and bifold.</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import store from "../store";
import InstructorResources from "../services/instructor-resources.js";
export default {
  name: "InstructorResources",
  data() {
    return {
      resources: [],
      allResources: [],
      categories: [],
      tags: [],
      pagination: {}
    };
  },
  computed: {
    title() {
      let title = "Instructor Resources";

      if (this.$route.query.category) {
        title =
          "Instructor Resource Category: " +
          this.getCategoryName(this.$route.query.category);
      }

      if (this.$route.query.tag) {
        title =
          "Instructor Resource Tag: " + this.getTagName(this.$route.query.tag);
      }

      if (this.$route.query.s) {
        title = "Instructor Resource Search: " + this.$route.query.s;
      }

      if (this.$route.query.page > 1) {
        title = title + " - Page " + this.$route.query.page;
      }

      if (this.$route.query.week) {
        title = title + " - Week " + this.$route.query.week;
      }

      return title;
    },
    userResourceFilterParams() {
      return {
        ...this.$route.query
      };
    }
  },
  watch: {
    "$route.query.s": function(s) {
      this.fetchResources();
    },
    "$route.query.category": function(category) {
      this.fetchResources();
    },
    "$route.query.tag": function(s) {
      this.fetchResources();
    },
    "$route.query.page": function(s) {
      this.fetchResources();
    },
    "$route.query.week": function(s) {
      this.fetchResources();
    }
  },
  created() {
    let resources = InstructorResources.all(this.userResourceFilterParams);
    let categories = InstructorResources.categories();
    let tags = InstructorResources.tags();
    Promise.all([resources, categories, tags])
      .then(responseArr => {
        this.setResources(responseArr[0]);
        this.categories = responseArr[1].data;
        this.tags = responseArr[2].data;
      })
      .catch(err => {
        console.error(err);
      });
  },
  methods: {
    fetchResources() {
      InstructorResources.all(this.userResourceFilterParams).then(res => {
        this.setResources(res);
        window.scrollTo(0, 0);
      });
    },
    setResources(res) {
      this.resources = res.data;
      this.pagination = res;
    },
    fetchCategories() {
      InstructorResources.categories().then(res => {
        console.log(res.data);
        this.categories = res.data;
      });
    },
    fetchTags() {
      InstructorResources.tags().then(res => {
        this.tags = res.data;
      });
    },
    setPage(page = 1) {
      this.$router.push({
        query: { ...this.$route.query, page: page }
      });
    },
    getCategoryName(id) {
      let name = '';

      this.categories.forEach(function(category) {
        if (category.id == id) {
          name = category.name;
        }
        category.children.forEach(function(child) {
          if (child.id == id) {
            name = child.name;
          }
        });
      });

      return name;
    },
    getTagName(id) {
      let tag = this.tags.find(function(tag) {
        return tag.id == id;
      });

      if (tag) {
        return tag.name;
      }

      return "";
    },
    handleScroll(evt, el) {
      let height = document.body.scrollHeight;

      if (window.scrollY > 400 && window.innerWidth > 990) {
        if (height > 2500) {
          el.classList.add("float");
        }
      } else {
        el.classList.remove("float");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  opacity: 0;
  animation: 600ms eventEnter forwards ease-in-out;
}
.card-body {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.center-title {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.card-resource {
  &-info {
    min-width: 130px;
    padding-right: 15px;
  }
  @media (max-width: 600px) {
    &-btn-wrapper {
      display: flex;
      flex-direction: column;
    }
  }
}

.store-link-text {
  font-size: 1.5em;
}

/*.resources-container { min-height: 400px; }*/

.float {
  position: fixed;
  top: 100px;
  margin-right: 20px;
  max-width: 344px;
  z-index: 1;
}

.btn-download {
  white-space: nowrap;
}

@keyframes fade-in {
  to {
    opacity: 1;
  }
}

@keyframes eventEnter {
  0% {
    /*transform: translateY(2rem);*/
  }
  100% {
    /*transform: translateY(0);*/
    opacity: 1;
  }
}
</style>
